var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppMoreOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5401 8.81062C19.1748 8.81062 20.5001 7.48539 20.5001 5.85063C20.5001 4.21586 19.1748 2.89062 17.5401 2.89062C15.9053 2.89062 14.5801 4.21586 14.5801 5.85063C14.5801 7.48539 15.9053 8.81062 17.5401 8.81062Z",
    fill: "#CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46 8.81062C8.09476 8.81062 9.42 7.48539 9.42 5.85063C9.42 4.21586 8.09476 2.89062 6.46 2.89062C4.82524 2.89062 3.5 4.21586 3.5 5.85063C3.5 7.48539 4.82524 8.81062 6.46 8.81062Z",
    fill: "#CurrentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5401 21.1095C19.1748 21.1095 20.5001 19.7843 20.5001 18.1495C20.5001 16.5148 19.1748 15.1895 17.5401 15.1895C15.9053 15.1895 14.5801 16.5148 14.5801 18.1495C14.5801 19.7843 15.9053 21.1095 17.5401 21.1095Z",
    fill: "#CurrentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.46 21.1095C8.09476 21.1095 9.42 19.7843 9.42 18.1495C9.42 16.5148 8.09476 15.1895 6.46 15.1895C4.82524 15.1895 3.5 16.5148 3.5 18.1495C3.5 19.7843 4.82524 21.1095 6.46 21.1095Z",
    fill: "#CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMoreOutlined);
export default __webpack_public_path__ + "static/media/App-MoreOutlined.c8d0d25c0c9a10a7ab52fd0334aa63f9.svg";
export { ForwardRef as ReactComponent };